import { VsfContext } from '~/composables/context';
import { Logger } from '~/helpers/logger';
import { Cart } from '~/modules/GraphQL/types';

import { confirmedMutationCart } from '../cartMutationResult';

export const removeCouponCommand = {
  execute: async (context: VsfContext, { currentCart, customQuery, customHeaders = {} }) => {
    Logger.debug('[Magento]: Remove coupon from cart', { currentCart });

    const response = await context.$magento.api.removeCouponFromCart({
      cart_id: currentCart.id,
    }, customQuery, customHeaders);
    const { data, errors } = response || {};

    Logger.debug('[Result]:', { data });

    return {
      updatedCart: errors?.length && data?.removeCouponFromCart == null
        ? undefined : confirmedMutationCart({ data, errors }, 'removeCouponFromCart', currentCart.id) as Cart,
      updatedCoupon: { code: '' },
      errors,
    };
  },
};
